import { IonToast } from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { findProfileLocations } from "../../../store/userProfileLocation/actions/findProfileLocations";

export const AssignLocationsStatus = () => {
    const dispatch = useDispatch();
    const assignLocationsStatus = useSelector((state: RootState) => state.userProfileLocation.assignLocationsStatus);
    const userId = useSelector((state: RootState) => state.userProfileLocation.user.id);
    const profileId = useSelector((state: RootState) => state.userProfileLocation.profile.id);

    const handleFinishedAssign = () => {
        dispatch(findProfileLocations({userId: userId, profileId: profileId}));
    }

    return (
        <>
            {assignLocationsStatus === "succeeded" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Las plantas fueron asignadas correctamente"
                    position="bottom"
                    duration={3000}
                    color="success"
                />
            )}

            {assignLocationsStatus === "failed" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Ocurrió un error al asignar las plantas"
                    position="bottom"
                    duration={3000}
                    color="danger"
                />
            )}
        </>
    );
};
